module.exports = __webpack_public_path__ + "static/img/ls43.2cd63db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls43.png
// module id = 773b
// module chunks = 12